import { render, staticRenderFns } from "./rightSideBar.vue?vue&type=template&id=5d3b1884&"
import script from "./rightSideBar.vue?vue&type=script&lang=js&"
export * from "./rightSideBar.vue?vue&type=script&lang=js&"
import style0 from "./rightSideBar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports